// extracted by mini-css-extract-plugin
module.exports = {"emptyList":"EmptyPage_emptyList__5UQey","emptyPage":"EmptyPage_emptyPage__1VcMq"};